import { Lock, Unlock } from "lucide-react";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";
import { ViewMgtDeviceStatusValue } from "./ViewMgtDeviceStatusValue";
import { getLockSourceString, getLockTypeString } from "functions/deviceStatusUtils";

export default function ViewMgtDeviceStatusLock({ device }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {

  const lockResultLog = device?.LastSuccessfulLockResultLog ?? device?.LockResultLog;
  const lockType = getLockTypeString(lockResultLog?.requestLockType);
  let source = lockResultLog?.requestLock ? getLockSourceString(lockResultLog?.source) : "-";

  if (source === "Remote" && lockResultLog?.sourceRemote?.serialNumber) {
    source = `Remote (${lockResultLog?.sourceRemote?.serialNumber})`
  }
  
  return (
    <ViewMgtDevicePanel title="Lock" icon={ lockResultLog?.requestLock ? <Lock size={16} /> : <Unlock size={16} />}>
      <div className="grid grid-cols-1 gap-0">
        
        <ViewMgtDeviceStatusValue
          label="Status"
          value={lockResultLog?.requestLock ? "Locked" : "Unlocked"}
          color={lockResultLog?.requestLock ? "text-blue-500" : "text-red-500"}
          timestamp={lockResultLog?.requestLock ? lockResultLog?.logTimestamp : "-"}
          />

        <ViewMgtDeviceStatusValue
          label="Type"
          value={lockResultLog?.requestLock ? lockType : "-"}
          timestamp={lockResultLog?.requestLock ? lockResultLog?.logTimestamp : "-"}
          color={lockResultLog?.requestLock ? (lockType !== "Normal" ? "text-red-500" : "text-state-500") : "-"}
          />

        <ViewMgtDeviceStatusValue
          label="Source"
          value={source}
          color={"text-state-500"}
          timestamp={lockResultLog?.requestLock ? lockResultLog?.logTimestamp : "-"}
          />

      </div>
    </ViewMgtDevicePanel>
  );
}
